"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldNotForwardProp = exports.shouldForwardProp = void 0;
var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));
const shouldForwardProp = (allowedProps = []) => prop => {
  if (allowedProps.includes(prop)) {
    return true;
  }
  return (0, _isPropValid.default)(String(prop));
};
exports.shouldForwardProp = shouldForwardProp;
const shouldNotForwardProp = (forbiddenProps = []) => prop => !forbiddenProps.includes(prop);
exports.shouldNotForwardProp = shouldNotForwardProp;
//# sourceMappingURL=shouldForwardProp.js.map